import { Flex } from '@/components';

const ProfileDetailBox = ({ title, children }) => {
  return (
    <Flex className="app-profile-detail">
      <span className="app-profile-detail-title">{title}</span>
      <Flex className="app-profile-detail-box">
        {children}
      </Flex>
    </Flex>
  );
};

export default ProfileDetailBox;
